import { BucketObjectsPageWithSelection } from "./BucketObjectsPage";

export function ObjectDetailsPage() {
  return <BucketObjectsPageWithSelection />;
}
